<template>
  <div >
    <div class="incident">
      <div class="form-control">
        <label>{{ $gettext('Tipo de consulta') }}</label>
        <multiselect v-model="topic_selected"
                     :class="{'error': (!message_properties.interaction.valid && topic_selected == null)}"
                     :options="incidentInteractions.topics"
                     :allow-empty="false"
                     :searchable="false"
                     :placeholder="$gettext('Seleccionar tipo de consulta')"
                     track-by="id"
                     label="label"
                     @select="interactionSelected"
                     :show-labels="false"></multiselect>
          <div class="error-message-container" v-if="!message_properties.interaction.valid && topic_selected == null">
            <i class="error-message error-message-icon icon-message-info"></i>
            <span class="error-message">{{ $gettext('Por favor, selecciona un tipo de consulta') }}</span>
          </div>
      </div>
      <div class="form-control" v-if="topic_selected && topic_selected.motive.length > 0">
        <label>{{ $gettext('Motivo') + '*' }}</label>
        <multiselect
                     :class="{'error': (!message_properties.motive.valid && motive_selected == null)}"
                     v-model="motive_selected"
                     :options="topic_selected.motive"
                     :placeholder="$gettext('Seleccionar motivo')"
                     :allow-empty="false"
                     :searchable="false"
                     track-by="id"
                     label="label"
                     @select="motiveSelected"
                     :show-labels="false"></multiselect>
        <div class="error-message-container" v-if="!message_properties.motive.valid && motive_selected == null" >
            <i class="error-message error-message-icon icon-message-info"></i>
            <span class="error-message">{{ $gettext('Por favor, selecciona un motivo') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "IncidentInteractionInputs",
  props: ["value", "message_properties"],
  data() {
    return {
      topic_selected: null,
      motive_selected: null
    };
  },
  mounted() {
  },
  methods: {
    interactionSelected(selectedOption) {
      this.value.interaction = selectedOption ? selectedOption.id : null;
      this.topic_selected = selectedOption;
      this.motiveSelected(null)
    },
    motiveSelected(selectedOption) {
      this.motive_selected = selectedOption;
    },
    restoreSelections() {
      const topics = this.incidentInteractions && this.incidentInteractions.topics;
      if (!topics || topics.length === 0 || !this.value.interaction) return;

      const topic = topics.find(t => t.id === this.value.interaction);
      if (!topic) return;
      this.topic_selected = topic;

      if (this.value.motive && topic.motive && topic.motive.length > 0) {
        const motive = topic.motive.find(m => m.id === this.value.motive);
        if (motive) this.motive_selected = motive;
      }
    }
  },
  computed: {
    ...mapGetters(['incidentInteractions', 'hideIncidentInteractions'])
  },
  watch: {
    incidentInteractions: {
      immediate: true,
      handler() {
        this.restoreSelections();
      }
    },
    'value.interaction': {
      immediate: true,
      handler() {
        this.restoreSelections();
      }
    },
    'value.motive': {
      handler() {
        this.restoreSelections();
      }
    },
    topic_selected(val){
      console.log(val);
      if(this.topic_selected.motive.length === 0){
        this.value.motive = val.id;
        this.value.subject = val.label.substr(0, this.message_properties.subject.max_length);
      }
    },
    motive_selected(val){
      if(val){
        this.value.motive = val.id;
        this.value.subject = val.label.substr(0, this.message_properties.subject.max_length);
      }else{
        this.value.motive = null;
        this.value.subject = "";
      }
    }
  }
}
</script>
